// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J0X6","content":"styles_content__2Hpc1","tableWrap":"styles_tableWrap__1ySqR"};